import React from 'react';
import { Link } from 'react-router-dom';

export default function AppCard({ app }) {
  return (
    <Link to={app.path} className="app-card">
      <span className="app-card-name">{app.name}</span>
      <span className="app-card-description">{app.description}</span>
    </Link>
  );
}
